// code executed on create and edit pages
// eslint-disable-next-line max-len
$(document).ready(/\/mobility-management\/international-mobility\/([0-9]+\/)?(create|edit)/.test($(location)[0].pathname)&&function() {
    const form = $('#edit-international-mobility');

    const option = form.find('[name="type"]');
    const student = form.find('[name="student"]');
    const employee = form.find('[name="employee"]');
    const enrollmentStatus = form.find('[name="enrollmentStatus"]');
    const name = form.find('[name="name"]');
    const firstSpecialization = form.find('[name="firstSpecialization"]');
    const lecturerMajor = form.find('[name="lecturerMajor"]');
    const subtype = form.find('[name="subtype"]');
    const direction = form.find('[name="direction"]');

    const showCorrespondingInput = function() {
        const isEmployee = option.val() === 'employee';
        const isIncoming = direction.val() === 'incoming';
        const isEmployeeIncoming = isEmployee && isIncoming;

        if (isEmployee) {
            student.closest('div[class^="col"]').hide();
            enrollmentStatus.closest('div[class^="col"]').hide();
            firstSpecialization.closest('div[class^="col"]').hide();
            lecturerMajor.closest('div[class^="col"]').hide();
            employee.closest('div[class^="col"]').show();
            subtype.closest('div[class^="col"]').show();
            name.closest('div[class^="col"]').hide();
        } else {
            employee.closest('div[class^="col"]').hide();
            subtype.closest('div[class^="col"]').hide();
            student.closest('div[class^="col"]').show();
            enrollmentStatus.closest('div[class^="col"]').show();
            name.closest('div[class^="col"]').show();
            firstSpecialization.closest('div[class^="col"]').show();
            lecturerMajor.closest('div[class^="col"]').show();
            subtype.closest('div[class^="col"]').show();
        }

        if (isEmployeeIncoming) {
            student.closest('div[class^="col"]').hide();
            enrollmentStatus.closest('div[class^="col"]').hide();
            firstSpecialization.closest('div[class^="col"]').hide();
            lecturerMajor.closest('div[class^="col"]').hide();
            employee.closest('div[class^="col"]').hide();
            subtype.closest('div[class^="col"]').show();
            name.closest('div[class^="col"]').show();
            return;
        }

        if (!isEmployee) {
            if (enrollmentStatus.val() === 'false') {
                student.closest('div[class^="col"]').hide();
                name.closest('div[class^="col"]').show();
            } else {
                name.closest('div[class^="col"]').hide();
            }
        }
    };

    option.on('change', showCorrespondingInput);
    direction.on('change', showCorrespondingInput);
    enrollmentStatus.on('change', showCorrespondingInput);
});
